<div class="wrapper">
  <h1 *ngIf="invalidParams">Greška!</h1>
</div>